import React from "react";
import { Link, useLocation, type LinkProps, type Location } from "react-router-dom";

import { OFFICE_TYPES } from "../../../../dto/Company/CompanySettingsDto";
import { buildAdminDealPath } from "../../../../utils/adminDealRoutes";

export type AdminPanelNavigationState = {
  backgroundLocation?: Location;
  backgroundFiltersChanged?: boolean;
};

function isLocation(value: unknown): value is Location {
  return (
    typeof value === "object" && value !== null && "pathname" in value && typeof (value as { pathname?: unknown }).pathname === "string"
  );
}

export function getAdminPanelBackgroundLocation(location: Location) {
  const state = location.state as AdminPanelNavigationState | null;
  return isLocation(state?.backgroundLocation) ? state.backgroundLocation : undefined;
}

type Props = Omit<LinkProps, "id" | "replace" | "state" | "to"> & {
  id: number;
  officeType: OFFICE_TYPES;
  tab?: string;
};

export function getAdminPanelDealLinkProps(location: Location, id: number, officeType: OFFICE_TYPES, tab?: string) {
  const existingBackgroundLocation = getAdminPanelBackgroundLocation(location);
  const state: AdminPanelNavigationState = {
    backgroundLocation: existingBackgroundLocation || { ...location, state: null },
    backgroundFiltersChanged: (location.state as AdminPanelNavigationState | null)?.backgroundFiltersChanged,
  };
  return { to: buildAdminDealPath(id, officeType, tab), state, replace: Boolean(existingBackgroundLocation) };
}

const AdminPanelDealLink = React.memo(({ id, officeType, tab, ...linkProps }: Props) => {
  const location = useLocation();
  return <Link {...linkProps} {...getAdminPanelDealLinkProps(location, id, officeType, tab)} />;
});

export default AdminPanelDealLink;
